import { get } from "lodash";

//Events

export const deserializeMeeting = (meeting) => {
    const lodashGet = (key, defaultValue) => get(meeting, key, defaultValue);

    let data = {};
    if (meeting) {
        data = {
            id: lodashGet("_id", ""),
            meeting_type: lodashGet("meeting_type", "") === "LIVE" ? "Live" : lodashGet("meeting_type", ""),
            from_datetime: lodashGet("from_datetime", ""),
            to_datetime: lodashGet("to_datetime", ""),
            status: lodashGet("status"),
            meeting_link: lodashGet("meeting_link"),
            created_at: lodashGet("created_at", null),
            user_id: lodashGet("user_id", ""),
            name: lodashGet("name", ""),
            pending_documents: lodashGet("pending_documents") || [],
        };
    }
    return data;
};

export const deserializeMeetingList = (meetings) => {
    return meetings.map((meeting) => deserializeMeeting(meeting));
};
